export const getStringLengthWithoutSpaces = (str: string = ''): number => {
  return str.replace(/\s/g, '').length;
};
